<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center;  */
    color: #2c3e50;
    height: 100%;
    /* margin-top: 60px; */
  }
  html {
    height: 100%;
    min-width: 1280px;
  }
  body {
    height: 100%;
    margin: 0 0;
  }
  .dialog_body_line {
    display: flex;
    align-items: center;
  }
  .dialog_body_line + .dialog_body_line {
    margin-top: 16px;
  }
  .top_line{
    display: flex;
  }
  .top_line > *{
    flex: 0 1 auto;
  }
  .top_line + .top_line{
    margin-top: 10px;
  }
  .flex{
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
  .date_btns{
    display: inline-block;
    vertical-align: middle;
  }
  .date_btns_flex{
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }
  :not(.el-table__body-wrapper)::-webkit-scrollbar {
    width: 0;
  }

  .el-table__body-wrapper {
    overflow-x: hidden;
  }
</style>
